/**
 * Checks if the browser environment is defined by verifying if the `document` object exists.
 *
 * @returns {boolean} - Returns true if the `document` object is defined, indicating a browser environment; otherwise, returns false.
 */
export const isBrowserDefined = (): boolean => {
  return typeof document !== "undefined";
};
